<script>
import ViewTitle from '@/components/ViewTitle'
import ViewDescription from '@/components/ViewDescription'
import Button from '@/components/Button'
import FloatingLabelTextInput from '@/components/FloatingLabelTextInput'
import StoreLoyaltyCardFrame from '@/frames/storeLoyaltyCardFrame'
import StoreLoyaltyCardServices from '@/services/storeLoyaltyCard'
import EnvironmentUtils from '@/utils/environmentUtils'
import ObjectUtils from '@/utils/objectUtils'
import DialogUtils from '@/utils/dialogUtils'

export default
{
    name: 'loyalty-card-edit-rewards',

    created ()
    {
        StoreLoyaltyCardFrame.initFrame(this.$store, this.storeId, true)
    },

    render () 
    {
        return (
            <div id='loyalty-card-edit-rewards-view'>
                <view-title back-action={true}>Éditer les récompenses</view-title>
                <view-description>
                    Vous pouvez ajouter les récompenses que vos clients pourront échanger contre leurs points de fidélité.
                </view-description>
                <Button id='add-reward-btn' type='secondary' text='ajouter une récompense' icon={require('@/assets/img/plus.svg')} on-click={this.onAddRewardClicked} />
                {
                    this.rewards.map(r =>
                    {
                        return (
                            <div class='reward'>
                                <div class='reward-title'>{r.rewardName || 'Donnez la description de votre récompense'}</div>
                                <floating-label-text-input placeholder='Description' v-model={r.rewardName} />
                                <floating-label-text-input placeholder='Coût' v-model={r.rewardPrice} type='number' />
                                <div class='column'>
                                    <Button class='save-reward' type='primary' text='Enregistrer' on-click={(e, b) => this.onSaveRewardClicked(r, b)}
                                        v-show={this.canRewardBeSaved(r)} />
                                    <Button class='delete-reward' type='danger' outlined={true} size='small' text='Supprimer'
                                        on-click={(e, b) => this.onDeleteRewardClicked(r, b)} />
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        )
    },

    data () 
    {
        return {
            originalRewards: []
        }
    },

    computed:
    {
        storeId ()
        {
            return this.$route.params.storeId
        },

        rewards ()
        {
            return this.$store.state.storeLoyaltyCard.storeRewards[this.storeId] || []
        }
    },

    watch:
    {
        rewards ()
        {
            this.originalRewards = ObjectUtils.clone(this.rewards)
        }
    },

    mounted ()
    {
    },

    methods:
    {
        canRewardBeSaved (r)
        {
            return (r.isDraft || (JSON.stringify(this.originalRewards.find(re => re.rewardId == r.rewardId)) != JSON.stringify(r)))
                && r.rewardPrice > 0
        },

        onAddRewardClicked ()
        {
            this.$store.commit('storeLoyaltyCard/updateStoreRewards',
            {
                storeId: this.storeId,
                rewardId: -Math.ceil(Math.random() * 10000),
                rewardName: '',
                rewardPrice: '',
                isDraft: true
            })
        },

        async onSaveRewardClicked (r, button)
        {
            button.showSpinner = true

            if (r.isDraft)
            {
                const res = await StoreLoyaltyCardServices.createStoreReward(this.$store.state.user.token, EnvironmentUtils.cityId, this.storeId, r)
                await this.deleteReward(r)
                this.$store.commit('storeLoyaltyCard/updateStoreRewards', res)
            }
            else
            {
                const res = await StoreLoyaltyCardServices.updateStoreReward(this.$store.state.user.token, EnvironmentUtils.cityId, this.storeId, r.rewardId, r)
                this.$store.commit('storeLoyaltyCard/updateStoreRewards', res)
            }

            button.showSpinner = false
        },

        async onDeleteRewardClicked (r, button)
        {
            button.showSpinner = true
            await this.deleteReward(r)
            button.showSpinner = false
        },

        async deleteReward (r)
        {
            if (!r.isDraft)
            {
                const confirmed = await DialogUtils.waitForUserConfirmationAsync
                ({
                    title: 'Voulez-vous vraiment effectuer cette action ?',
                    description: `La suppression de <b>${r.rewardName}</b> sera irréversible`,
                })
                if (!confirmed) return

                await StoreLoyaltyCardServices.deleteStoreReward(this.$store.state.user.token, EnvironmentUtils.cityId, this.storeId, r.rewardId)
            }

            await this.$store.dispatch('storeLoyaltyCard/removeRewardById', r.rewardId)
        }
    },

    components:
    {
        ViewTitle,
        ViewDescription,
        Button,
        FloatingLabelTextInput
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#loyalty-card-edit-rewards-view
{
    display: flex;
    flex-direction: column;
    margin-bottom: calc(var(--theme-horizontal-menu-height) + 2vh);
    margin-left: 10px;
    margin-right: 10px;

    .OnTablet({
        margin-left: auto;
        margin-right: auto;
        max-width: 550px;
    });
    .OnDesktop({ margin-top: 8vh; });

    .reward
    {
        margin-top: 20px;
        padding: 10px;
        border-radius: 4px;
        background-color: var(--theme-content-background-color);
        box-shadow: var(--theme-box-shadow-soft);

        .reward-title
        {
            font-size: 20px;
            font-weight: bold;
            margin-left: 7px;
            margin-bottom: 15px;
        }

        .floating-label-text-input
        {
            &:not(:first-of-type)
            {
                margin-top: 10px;
            }
        }

        .button
        {
            margin-top: 15px;
            width: -webkit-fill-available;

            &:first-of-type
            {
                margin-right: 5px;
            }

            &.danger-type
            {
                border: none;
            }
        }
    }

    .column
    {
        display: flex;
        flex-direction: row;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/LoyaltyCardEditRewards.vue